// Vite Rails entrypoint
console.log('Vite Rails loaded')

// Import CSS for React components
import '../components/index.css'
import '../components/score-widget.css'
import '../components/icon-picker.css'
import '../components/numeric-dependencies-chart.css'
import '../components/mood-widget.css'

// Export React components to window for Rails integration
import { mountScoreWidget } from '../components/ScoreWidgetContainer'
import { mountIconPicker, unmountIconPicker } from '../components/IconPickerContainer'
import { mountNumericDependenciesChart } from '../components/NumericDependenciesChart'
import { mountDiaryDayPage } from '../components/DiaryDayPageContainer'
import { mountNumericFieldSetForm, unmountNumericFieldSetForm } from '../components/NumericFieldSetFormContainer'
import { mountAgendaPage } from '../components/AgendaPageContainer'
import { mountCalendarPage } from '../components/CalendarPageContainer'
import { mountMoodWidget } from '../components/MoodWidgetContainer'
import { mountMainNavigation } from '../components/MainNavigationContainer'
import { mountStatsPage } from '../components/StatsPageContainer'
import { mountReportsListPage } from '../components/ReportsListPageContainer'
import { mountReportDetailPage } from '../components/ReportDetailPageContainer'
import { mountAchievementsPage } from '../components/AchievementsPageContainer'
import { mountCategoriesManager } from '../components/CategoriesManagerContainer'
import { mountAdditionalActivitiesWidget } from '../components/AdditionalActivitiesWidgetContainer'
import { mountAdditionalActivitiesManagement } from '../components/AdditionalActivitiesManagementContainer'
import { mountAchievementUnlockModal } from '../components/AchievementUnlockModalContainer'
import { mountSubscriptionModal } from '../components/SubscriptionModalContainer'
import { mountFeedbackModal } from '../components/FeedbackModalContainer'
import { mountFeatureLockModal, showFeatureLockModal } from '../components/FeatureLockModalContainer'
import { mountMealInput, unmountMealInput } from '../components/MealInputContainer'
import { mountCategoryForm, unmountCategoryForm } from '../components/CategoryFormContainer'
import { mountToggleFieldForm, unmountToggleFieldForm } from '../components/ToggleFieldFormContainer'
import { mountFieldSetForm, unmountFieldSetForm } from '../components/FieldSetFormContainer'
import { mountNumericFieldForm, unmountNumericFieldForm } from '../components/NumericFieldFormContainer'
import { mountGoalForm, unmountGoalForm } from '../components/GoalFormContainer'
import { mountGoalsOverviewPage, unmountGoalsOverviewPage } from '../components/GoalsOverviewPageContainer'
import { mountAutomationForm, unmountAutomationForm } from '../components/AutomationFormContainer'
import { mountDiarySettingsForm, unmountDiarySettingsForm } from '../components/DiarySettingsFormContainer'
import { mountScoreWidgetForm, unmountScoreWidgetForm } from '../components/ScoreWidgetFormContainer'
import { mountScoreWidgetFieldForm, unmountScoreWidgetFieldForm } from '../components/ScoreWidgetFieldFormContainer'
import { mountUserProfileForm, unmountUserProfileForm } from '../components/UserProfileFormContainer'
import { mountAdminDashboard } from '../components/AdminDashboardContainer'
import { mountAdminUsersPage } from '../components/AdminUsersPageContainer'
import { mountAdminUserDetailPage } from '../components/AdminUserDetailPageContainer'
import { mountAdminCouponsPage } from '../components/AdminCouponsPageContainer'
import { mountAdminCouponDetailPage } from '../components/AdminCouponDetailPageContainer'
import { mountAdminFeedbacksPage } from '../components/AdminFeedbacksPageContainer'
import { mountAdminErrorLogsPage } from '../components/AdminErrorLogsPageContainer'
import { mountAdminAIReportFeedbacksPage } from '../components/AdminAIReportFeedbacksPageContainer'
import { mountAdminEmailLogsPage } from '../components/AdminEmailLogsPageContainer'
import { mountAdminAnalyticsPage } from '../components/AdminAnalyticsPageContainer'
import { mountAdminAIModelsPage } from '../components/AdminAIModelsPageContainer'
import { mountAdminFeedbackDetailPage } from '../components/AdminFeedbackDetailPageContainer'
import { mountAdminErrorLogDetailPage } from '../components/AdminErrorLogDetailPageContainer'
import { mountAdminEmailLogDetailPage } from '../components/AdminEmailLogDetailPageContainer'
import { mountAdminEmailAnalyticsPage } from '../components/AdminEmailAnalyticsPageContainer'
import { mountAdminAIReportFeedbackDetailPage } from '../components/AdminAIReportFeedbackDetailPageContainer'
import { mountAdminAIModelDetailPage } from '../components/AdminAIModelDetailPageContainer'

window.mountScoreWidget = mountScoreWidget
window.mountIconPicker = mountIconPicker
window.unmountIconPicker = unmountIconPicker
window.mountNumericDependenciesChart = mountNumericDependenciesChart
window.mountDiaryDayPage = mountDiaryDayPage
window.mountNumericFieldSetForm = mountNumericFieldSetForm
window.unmountNumericFieldSetForm = unmountNumericFieldSetForm
window.mountAgendaPage = mountAgendaPage
window.mountCalendarPage = mountCalendarPage
window.mountMoodWidget = mountMoodWidget
window.mountMainNavigation = mountMainNavigation
window.mountStatsPage = mountStatsPage
window.mountReportsListPage = mountReportsListPage
window.mountReportDetailPage = mountReportDetailPage
window.mountAchievementsPage = mountAchievementsPage
window.mountCategoriesManager = mountCategoriesManager
window.mountAdditionalActivitiesWidget = mountAdditionalActivitiesWidget
window.mountAdditionalActivitiesManagement = mountAdditionalActivitiesManagement
window.mountAchievementUnlockModal = mountAchievementUnlockModal
window.mountSubscriptionModal = mountSubscriptionModal
window.mountFeedbackModal = mountFeedbackModal
window.mountFeatureLockModal = mountFeatureLockModal
window.showFeatureLockModal = showFeatureLockModal
window.mountMealInput = mountMealInput
window.unmountMealInput = unmountMealInput
window.mountCategoryForm = mountCategoryForm
window.unmountCategoryForm = unmountCategoryForm
window.mountToggleFieldForm = mountToggleFieldForm
window.unmountToggleFieldForm = unmountToggleFieldForm
window.mountFieldSetForm = mountFieldSetForm
window.unmountFieldSetForm = unmountFieldSetForm
window.mountNumericFieldForm = mountNumericFieldForm
window.unmountNumericFieldForm = unmountNumericFieldForm
window.mountGoalForm = mountGoalForm
window.unmountGoalForm = unmountGoalForm
window.mountGoalsOverviewPage = mountGoalsOverviewPage
window.unmountGoalsOverviewPage = unmountGoalsOverviewPage
window.mountAutomationForm = mountAutomationForm
window.unmountAutomationForm = unmountAutomationForm
window.mountDiarySettingsForm = mountDiarySettingsForm
window.unmountDiarySettingsForm = unmountDiarySettingsForm
window.mountScoreWidgetForm = mountScoreWidgetForm
window.unmountScoreWidgetForm = unmountScoreWidgetForm
window.mountScoreWidgetFieldForm = mountScoreWidgetFieldForm
window.unmountScoreWidgetFieldForm = unmountScoreWidgetFieldForm
window.mountUserProfileForm = mountUserProfileForm
window.unmountUserProfileForm = unmountUserProfileForm
window.mountAdminDashboard = mountAdminDashboard
window.mountAdminUsersPage = mountAdminUsersPage
window.mountAdminUserDetailPage = mountAdminUserDetailPage
window.mountAdminCouponsPage = mountAdminCouponsPage
window.mountAdminCouponDetailPage = mountAdminCouponDetailPage
window.mountAdminFeedbacksPage = mountAdminFeedbacksPage
window.mountAdminErrorLogsPage = mountAdminErrorLogsPage
window.mountAdminAIReportFeedbacksPage = mountAdminAIReportFeedbacksPage
window.mountAdminEmailLogsPage = mountAdminEmailLogsPage
window.mountAdminAnalyticsPage = mountAdminAnalyticsPage
window.mountAdminAIModelsPage = mountAdminAIModelsPage
window.mountAdminFeedbackDetailPage = mountAdminFeedbackDetailPage
window.mountAdminErrorLogDetailPage = mountAdminErrorLogDetailPage
window.mountAdminEmailLogDetailPage = mountAdminEmailLogDetailPage
window.mountAdminEmailAnalyticsPage = mountAdminEmailAnalyticsPage
window.mountAdminAIReportFeedbackDetailPage = mountAdminAIReportFeedbackDetailPage
window.mountAdminAIModelDetailPage = mountAdminAIModelDetailPage
